<template>
  <v-dialog v-model="dialogVisible" max-width="920" persistent>
    <v-card v-if="registro" class="rounded-0">
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title>Detalle del registro</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="cerrar" title="Cerrar" dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="6">
            <strong>{{ $t("registroActividad.labels.fecha") }}:</strong>
            {{ getDateTimeFormat(registro.createdAt) }}
          </v-col>
          <v-col cols="12" md="6">
            <strong>{{ $t("registroActividad.labels.usuario") }}:</strong>
            {{ registro.user ? registro.user.username : "-" }}
          </v-col>
          <v-col cols="12" md="6">
            <strong>{{ $t("registroActividad.labels.accion") }}:</strong>
            <v-chip :color="getActionColor(registro.action)" small dark>
              {{ getActionLabel(registro.action) }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="6">
            <strong>{{ $t("registroActividad.labels.entidad") }}:</strong>
            {{ getEntityLabel(registro.entity) }}
          </v-col>
          <v-col cols="12" md="6" v-if="registro.deposito">
            <strong>{{ $t("registroActividad.labels.deposito") }}:</strong>
            {{ registro.deposito.nombre }}
          </v-col>
          <v-col cols="12">
            <strong>{{ $t("registroActividad.labels.detalles") }}:</strong>
            {{ registro.details || "-" }}
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div v-if="changesFiltered && changesFiltered.length > 0">
          <h4 class="mb-3">Cambios</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor anterior</th>
                  <th>Valor nuevo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, i) in changesFiltered" :key="i">
                  <td>{{ getFieldLabel(c.field) }}</td>
                  <td>{{ formatChangeValue(c.oldValue) }}</td>
                  <td>{{ formatChangeValue(c.newValue) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="showResourceDataAsTable && resourceDataRows.length > 0" class="mt-4">
          <h4 class="mb-3">{{ registro.action === 'CREATE' ? $t('registroActividad.labels.datosCreados') : $t('registroActividad.labels.datosRecurso') }}</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in resourceDataRows" :key="i">
                  <td>{{ row.field }}</td>
                  <td>{{ formatChangeValue(row.value) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="itemsPresupuestoOrden.length > 0" class="mt-4">
          <h4 class="mb-3">Ítems</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Precio unit.</th>
                  <th>Total línea</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(it, idx) in itemsPresupuestoOrden" :key="idx">
                  <td>{{ it.productoNombre }}</td>
                  <td>{{ it.cantidad }}</td>
                  <td>{{ it.precioUnitario }}</td>
                  <td>{{ it.totalLinea }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="criteriosDisplay && criteriosDisplay.length > 0" class="mt-4">
          <h4 class="mb-3">{{ $t('registroActividad.labels.criteriosOferta') || 'Criterios de la oferta' }}</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Criterio</th>
                  <th>Valores</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in criteriosDisplay" :key="i">
                  <td>{{ row.label }}</td>
                  <td>{{ row.values.join(', ') }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="itemsPresupuestoOrden.length > 0" class="mt-4">
          <h4 class="mb-3">Ítems</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Precio unit.</th>
                  <th>Total línea</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(it, idx) in itemsPresupuestoOrden" :key="idx">
                  <td>{{ it.productoNombre }}</td>
                  <td>{{ it.cantidad }}</td>
                  <td>{{ it.precioUnitario }}</td>
                  <td>{{ it.totalLinea }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="itemsImportacionProductos.length > 0" class="mt-4">
          <h4 class="mb-3">Productos importados</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Código de barras</th>
                  <th>Stock inicial</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(it, idx) in itemsImportacionProductos" :key="idx">
                  <td>{{ it.resourceName }}</td>
                  <td>{{ it.codigoBarras }}</td>
                  <td>{{ it.stock }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>

        <div v-if="registro.maskedFields && registro.maskedFields.length > 0" class="mt-3">
          <v-alert type="info" dense>
            Campos modificados pero no mostrados por seguridad:
            {{ registro.maskedFields.join(", ") }}
          </v-alert>
        </div>

        <div v-if="registro.action === 'UPDATE_MANY' && getBulkSummary(registro.resourceData)" class="mt-3">
          <v-alert type="info" dense>
            {{ getBulkSummary(registro.resourceData) }}
          </v-alert>
        </div>

        <div v-if="registro.action === 'UPDATE_MANY' && bulkItems.length > 0" class="mt-4">
          <h4 class="mb-3">{{ $t('registroActividad.labels.productosModificados') }}</h4>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th v-if="hasTransferenciaFields">Origen → Destino</th>
                  <th>Cambios</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in bulkItems" :key="i">
                  <td>{{ item.resourceName || '-' }}</td>
                  <td v-if="hasTransferenciaFields">
                    <span v-if="item.depositoOrigenNombre && item.depositoDestinoNombre">
                      {{ item.depositoOrigenNombre }} → {{ item.depositoDestinoNombre }}
                      <span class="text-caption">({{ item.cantidad }} und.)</span>
                    </span>
                    <span v-else-if="item.depositoOrigenId && item.depositoDestinoId">
                      {{ item.cantidad }} und.
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <div v-for="(c, j) in (item.changes || [])" :key="j" class="text-caption">
                      {{ getFieldLabel(c.field) }}: {{ formatChangeValue(c.oldValue) }} → {{ formatChangeValue(c.newValue) }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title>Detalle del registro</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="cerrar" title="Cerrar" dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import RegistroActividadProvider from "../../providers/RegistroActividadProvider";
import { DayjsMixin } from "@dracul/dayjs-frontend";

const ESTADO_PRESUPUESTO_Y_VENTA_LABELS = {
  CREADO: "Creado",
  PEDIDO_CREADO: "Orden de venta creada",
  CONFIRMADO: "Confirmada",
  ENVIADO: "Enviada al cliente",
  RECIBIDO: "Recibida por el cliente",
  CANCELADO: "Cancelada",
  PAGADO: "Pagada",
  PAGO_PARCIAL: "Parcialmente pagada",
  NO_PAGADO: "Impaga",
};

const TIPO_MOVIMIENTO_LABELS = {
  VENTA: "Venta",
  DEVOLUCION: "Devolución",
  PAGO_ORDEN_VENTA: "Orden de venta pagada",
  PAGO_ORDEN_COMPRA: "Orden de compra pagada",
  REEMBOLSO_PAGO_ORDEN_COMPRA: "Reembolso orden de compra",
  REEMBOLSO_PAGO_ORDEN_VENTA: "Reembolso Orden de Venta",
};

export default {
  name: "RegistroActividadDetalle",
  mixins: [DayjsMixin],
  props: {
    value: Boolean,
    registroId: String,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    showResourceDataAsTable() {
      return this.registro && (this.registro.action === "CREATE" || this.registro.action === "DELETE") && this.registro.resourceData;
    },
    resourceDataRows() {
      if (!this.registro || !this.registro.resourceData) return [];
      const obj = typeof this.registro.resourceData === "string"
        ? (() => { try { return JSON.parse(this.registro.resourceData); } catch { return {}; } })()
        : this.registro.resourceData;
      if (!obj || typeof obj !== "object" || Array.isArray(obj)) return [];
      const skip = ["__v", "id", "_id", "deposito", "companyId", "items", "criterios"];
      const isIdField = (key) => skip.includes(key) || /Id$/i.test(key);
      return Object.entries(obj)
        .filter(([key]) => !isIdField(key))
        .map(([key, val]) => ({ field: this.getFieldLabel(key), value: val }));
    },
    criteriosDisplay() {
      if (!this.registro || !this.registro.resourceData || this.registro.entity !== "Oferta") return null;
      const obj = typeof this.registro.resourceData === "string"
        ? (() => { try { return JSON.parse(this.registro.resourceData); } catch { return {}; } })()
        : this.registro.resourceData;
      const c = obj?.criterios;
      if (!c || typeof c !== "object") return null;
      const parts = [];
      if (Array.isArray(c.productos) && c.productos.length > 0) {
        const nombres = c.productos.map((p) => (typeof p === "string" ? p : (p && p.nombre) || (p && p.marca?.nombre && p.modelo?.nombre && p.tamanio?.tamanio ? `${p.marca.nombre} - ${p.modelo.nombre} - ${p.tamanio.tamanio}` : null) || "-")).filter(Boolean);
        if (nombres.length) parts.push({ label: "Productos", values: nombres });
      }
      if (Array.isArray(c.marcas) && c.marcas.length > 0) {
        const nombres = c.marcas.map((m) => (typeof m === "string" ? m : (m && m.nombre) || "-")).filter((x) => x && x !== "-");
        if (nombres.length) parts.push({ label: "Marcas", values: nombres });
      }
      if (Array.isArray(c.modelos) && c.modelos.length > 0) {
        const nombres = c.modelos.map((m) => (typeof m === "string" ? m : (m && m.nombre) || "-")).filter((x) => x && x !== "-");
        if (nombres.length) parts.push({ label: "Modelos", values: nombres });
      }
      if (Array.isArray(c.tamanios) && c.tamanios.length > 0) {
        const vals = c.tamanios.map((t) => (typeof t === "string" ? t : (t && (t.tamanio || t.nombre)) || "-")).filter((x) => x && x !== "-");
        if (vals.length) parts.push({ label: "Tamaños", values: vals });
      }
      return parts.length > 0 ? parts : null;
    },
    bulkItems() {
      if (!this.registro || !this.registro.resourceData || this.registro.action !== "UPDATE_MANY") return [];
      const obj = typeof this.registro.resourceData === "string"
        ? (() => { try { return JSON.parse(this.registro.resourceData); } catch { return {}; } })()
        : this.registro.resourceData;
      const items = obj?.items;
      return Array.isArray(items) ? items : [];
    },
    itemsPresupuestoOrden() {
      if (!this.registro || !this.registro.resourceData) return [];
      const entity = this.registro.entity;
      if (entity !== "Presupuesto" && entity !== "OrdenVenta" && entity !== "OrdenCompra") return [];
      const obj = typeof this.registro.resourceData === "string"
        ? (() => { try { return JSON.parse(this.registro.resourceData); } catch { return {}; } })()
        : this.registro.resourceData;
      const items = obj?.items;
      if (!Array.isArray(items) || items.length === 0) return [];
      return items.map((it) => ({
        productoNombre: it?.productoNombre ?? it?.producto?.nombre ?? "-",
        cantidad: it?.cantidad != null ? Number(it.cantidad) : "-",
        precioUnitario: it?.precioUnitario != null ? Number(it.precioUnitario).toFixed(2) : "-",
        totalLinea: it?.precioFinalLinea != null ? Number(it.precioFinalLinea).toFixed(2) : (it?.precioTotal != null ? Number(it.precioTotal).toFixed(2) : "-"),
      }));
    },
    itemsImportacionProductos() {
      if (!this.registro || !this.registro.resourceData) return [];
      if (this.registro.entity !== "Producto" || this.registro.action !== "CREATE") return [];
      const obj = typeof this.registro.resourceData === "string"
        ? (() => { try { return JSON.parse(this.registro.resourceData); } catch { return {}; } })()
        : this.registro.resourceData;
      if (!obj || obj.tipo !== "Importacion de productos masivos") return [];
      const items = obj.items;
      if (!Array.isArray(items) || items.length === 0) return [];
      return items.map((it) => ({
        resourceName: it.resourceName || "-",
        codigoBarras: it.codigoBarras || "-",
        stock: it.stock != null ? it.stock : "-",
      }));
    },
    hasTransferenciaFields() {
      return this.bulkItems.some((i) => i.depositoOrigenId != null || i.depositoDestinoId != null);
    },
    changesFiltered() {
      if (!this.registro?.changes?.length) return [];
      return this.registro.changes.filter((c) => {
        const f = c?.field;
        return f && f !== "id" && f !== "_id" && !/Id$/i.test(f);
      });
    },
  },
  data() {
    return {
      registro: null,
    };
  },
  watch: {
    value(v) {
      if (v && this.registroId) {
        this.cargarDetalle();
      } else {
        this.registro = null;
      }
    },
    registroId(id) {
      if (this.value && id) {
        this.cargarDetalle();
      }
    },
  },
  methods: {
    cerrar() {
      this.dialogVisible = false;
    },
    async cargarDetalle() {
      if (!this.registroId) return;
      this.registro = null;
      try {
        const r = await RegistroActividadProvider.find(this.registroId);
        this.registro = r.data.registroActividadFind;
      } catch (err) {
        console.error(err);
      }
    },
    getActionColor(action) {
      const colors = {
        CREATE: "success",
        UPDATE: "info",
        UPDATE_MANY: "info",
        DELETE: "error",
        LOGIN: "primary",
      };
      return colors[action] || "grey";
    },
    getActionLabel(action) {
      return this.$t(`registroActividad.actions.${action}`) || action;
    },
    getEntityLabel(entity) {
      if (!entity) return "-";
      if (entity === "Tamanio") return "Tamaño";
      if (entity === "OrdenVenta") return "Orden de venta";
      if (entity === "OrdenCompra") return "Orden de Compra";
      return entity;
    },
    getFieldLabel(field) {
      const labels = {
        deposito: this.$t("registroActividad.labels.deposito"),
        companyId: "Empresa",
        marca: "Marca",
        modelo: "Modelo",
        tamanio: "Tamaño",
        nombre: "Nombre",
        codigoBarras: "Código de barras",
        codigoBarrasProveedor: "Código barras proveedor",
        precioVenta: "Precio venta",
        precioCompra: "Precio compra",
        stock: "Stock",
        stockAlerta: "Stock alerta",
        fechaVencimiento: "Fecha vencimiento",
        descuentoProveedor: "Descuento proveedor",
        ivaPorcentaje: "IVA %",
        porcentajeSobreCosto: "% sobre costo",
        creadoPor: this.$t("registroActividad.labels.creadoPor") || "Creado por",
        createdAt: this.$t("registroActividad.labels.createdAt") || "Creado el",
        updatedAt: this.$t("registroActividad.labels.updatedAt") || "Actualizado el",
        diasSemana: "Días de la semana",
        mediosPago: "Medios de pago",
        fechaInicio: "Fecha inicio",
        fechaFin: "Fecha fin",
        estado: "Estado",
        estadoPago: "Estado de pago",
        fechaPagoCompletado: "Fecha pago total",
        montoComisionVendedor: "Comisión vendedor",
        intentos: "Intentos",
        emailEnviado: "Email enviado",
        total: "Total",
        tipoComprobante: "Tipo de comprobante",
        codigoTipoComprobante: "Código tipo comprobante",
        puntoVenta: "Punto de venta",
        numeroComprobante: "Número de comprobante",
        fechaEmision: "Fecha de emisión",
        iva: "IVA",
        subtotal: "Subtotal",
        subtotalConOfertas: "Subtotal con ofertas",
        descuento: "Descuento %",
        recargo: "Recargo %",
        descuentoMonto: "Monto descuento",
        recargoMonto: "Monto recargo",
        clienteSnapshot: "Cliente (resumen)",
        companySnapshot: "Empresa (resumen)",
        numeroPresupuesto: "Nº presupuesto",
        precioTotal: "Precio total",
        pedidoId: "Pedido / Orden de venta",
        montoPagado: "Monto pagado",
        montoPedidoTotal: "Total del pedido",
        montoPedidoRestante: "Resto a pagar",
        medioDePago: "Medio de pago",
        items: "Ítems",
        clienteId: "Cliente",
        depositoId: "Depósito",
        presupuestoId: "Presupuesto",
        movimientoId: "Movimiento",
        fecha: "Fecha",
      };
      if (labels[field]) return labels[field];
      if (field && typeof field === "string" && /[a-z][A-Z]/.test(field)) {
        return field
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (s) => s.toUpperCase())
          .trim();
      }
      return field;
    },
    formatChangeValue(val) {
      if (val === undefined || val === null) return "-";
      if (typeof val === "string" && /\[object Object\]/.test(val)) {
        return "—";
      }
      if (typeof val === "string" && ESTADO_PRESUPUESTO_Y_VENTA_LABELS[val]) {
        return ESTADO_PRESUPUESTO_Y_VENTA_LABELS[val];
      }
      if (typeof val === "string" && TIPO_MOVIMIENTO_LABELS[val]) {
        return TIPO_MOVIMIENTO_LABELS[val];
      }
      let arr = null;
      if (Array.isArray(val)) arr = val;
      else if (typeof val === "string" && val.trim().startsWith("[")) {
        try { arr = JSON.parse(val); } catch { /* ignore */ }
      }
      if (Array.isArray(arr)) {
        const parts = arr.map((item) => {
          if (item == null) return "";
          if (typeof item === "string") return item;
          const nombre = item?.productoNombre ?? item?.nombre ?? item?.razonSocial ?? item?.name ?? item?.tamanio;
          const cantidad = item?.cantidad != null ? Number(item.cantidad) : null;
          const total = item?.precioFinalLinea ?? item?.precioTotal;
          if (nombre != null || cantidad != null || total != null) {
            const segs = [];
            if (nombre != null) segs.push(String(nombre));
            if (cantidad != null) segs.push(`Cant: ${cantidad}`);
            if (total != null) segs.push(`$${Number(total).toFixed(2)}`);
            return segs.join(" — ");
          }
          const d = item?.nombre ?? item?.razonSocial ?? item?.name ?? item?.tamanio;
          return d != null ? String(d) : "";
        }).filter(Boolean);
        return parts.length > 0 ? parts.join(" | ") : "-";
      }
      if (typeof val === "object") {
        const display =
          val.nombre ?? val.razonSocial ?? val.nombreFantasia ?? val.name ?? val.username ?? val.tamanio ?? val.direccion;
        if (display != null) return String(display);
        if (val.productos || val.marcas || val.modelos || val.tamanios) {
          const parts = [];
          if (Array.isArray(val.productos) && val.productos.length) {
            const n = val.productos.map((p) => (typeof p === "string" ? p : p?.nombre || p?.marca?.nombre ? `${p.marca?.nombre || ""} ${p.modelo?.nombre || ""} ${p.tamanio?.tamanio || ""}`.trim() || "-" : "-"));
            parts.push(`Productos: ${n.join(", ")}`);
          }
          if (Array.isArray(val.marcas) && val.marcas.length) {
            const n = val.marcas.map((m) => (typeof m === "string" ? m : m?.nombre) || "-");
            parts.push(`Marcas: ${n.join(", ")}`);
          }
          if (Array.isArray(val.modelos) && val.modelos.length) {
            const n = val.modelos.map((m) => (typeof m === "string" ? m : m?.nombre) || "-");
            parts.push(`Modelos: ${n.join(", ")}`);
          }
          if (Array.isArray(val.tamanios) && val.tamanios.length) {
            const n = val.tamanios.map((t) => (typeof t === "string" ? t : t?.tamanio || t?.nombre) || "-");
            parts.push(`Tamaños: ${n.join(", ")}`);
          }
          if (parts.length) return parts.join(" | ");
        }
        return JSON.stringify(val);
      }
      const str = String(val);
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(str)) {
        const formatted = this.getDateTimeFormat(val);
        return formatted || str;
      }
      return str;
    },
    getBulkSummary(data) {
      if (!data) return null;
      const obj = typeof data === "string" ? (() => { try { return JSON.parse(data); } catch { return {}; } })() : data;
      const count = obj.productosAfectados ?? obj.productosTransferidos;
      if (count === undefined) return null;
      const tipo = obj.tipo;
      const labels = {
        precio_porcentaje: "Precio (porcentaje)",
        precio_fijo: "Precio (monto fijo)",
        stock: "Stock",
        transferencia: "Transferencia entre depósitos",
        pricing: "Precio de venta",
      };
      const tipoLabel = labels[tipo] || tipo || "Operación";
      return `${tipoLabel}: ${count} producto(s) modificado(s)`;
    },
  },
};
</script>
